import { defineConfig, getUrl } from "../defineConfig";

export function createProdConfig(location: string) {
    return defineConfig({
        env: "production",
        apiURL: getUrl('https://backend.yuumi-soft.fr', location)
    });
}
